export enum DataTestIdsEnum {
  accessWalletBtn = 'accessWalletBtn',
  addressTableContainer = 'addressTableContainer',
  prevBtn = 'prevBtn',
  nextBtn = 'nextBtn',
  confirmBtn = 'confirmBtn',
  ledgerConfirmAddress = 'ledgerConfirmAddress',
  ledgerConnectBtn = 'ledgerConnectBtn',
  ledgerLoading = 'ledgerLoading',
  walletConnectLoading = 'walletConnectLoading',
  walletConnectQrCode = 'walletConnectQrCode',
  walletConnetModalTitle = 'walletConnetModalTitle',
  walletConnetModalSubtitle = 'walletConnetModalSubtitle',
  pendingTransactionsTitle = 'pendingTransactionsTitle',
  pendingTransactionsSubtitle = 'pendingTransactionsSubtitle',
  transactionToastContent = 'transactionToastContent',
  transactionToastTitle = 'transactionToastTitle',
  transactionDetailsToastBody = 'transactionDetailsToastBody',
  signTransactionBtn = 'signTransactionBtn',
}
